import { render, staticRenderFns } from "./FormulateTags.vue?vue&type=template&id=fcbe3f10&"
import script from "./FormulateTags.vue?vue&type=script&lang=js&"
export * from "./FormulateTags.vue?vue&type=script&lang=js&"
import style0 from "./FormulateTags.vue?vue&type=style&index=0&id=fcbe3f10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports